import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import DashboardP2P from "./Dashboard";
import PrivateRoute from "../../PrivateRoutes";
import Header from "../../Common/P2P/Header";
import LegalAuth from "./LegalAuth";
import AddmoneyIndex from "./Dashboard/AddMoney";
import paymentMode from "./Dashboard/AddMoney/paymentMode";
import BankDetails from "./Dashboard/AddMoney/bankDetails";
import InvestMore from "./Dashboard/AddMoney/investMore";
import InfoP2p from "./InfoP2p";
import InfoConfirmP2p from "./InfoConfirmP2p";
import LDCTerms from "./LDCTerms";
import LDCOTP from "./LDCOTP";
import AuthorityLetter from "./LegalAuth/authorityLetter";
import ReferEarn from "./ReferEarn";
import ManualKycLink from "./ManualKycLink";
import ConnectBank from "./ConnectBank";
import PersonalInfo from "./PersonalInfo";
import KycExists from "./KycExists";
import PersonalInfoDetails from "./PersonalInfo/PersonalInfoDetails";
import CkycDetails from "./CkycDetails";
import AdharCardKyc from "./AdharCardKyc";
import InvestFund from "./InvestFund";
import LenderAgreement from "./LenderAgreement";
import PaymentSuccess from "./Payment/paymentSuccess";
import Withdrawal from "./Dashboard/Withdrawal";
import Faq from "./Faq";
import FaqHelp from "./FaqHelp";
import FaqCongratulations from "./FaqCongratulations";
import Transactions from "./Transactions";
import WithdrawMoney from "./Dashboard/Withdrawal/withdrawMoney";
import Investments from "./Investments";
import PersonalInfoSecond from './PersonalInfo/PersonalInfoSecond'
import BorrowerInfo from "./Dashboard/BorrowerInfo";
import InvestmentSummaryInfo from "./Dashboard/InvestmentSummaryInfo";
import RecentTransactions from "./Dashboard/RecentTransactions";
import WithdrawalSuccess from "./Dashboard/WithdrawalSuccess";
import Tenure from "./Dashboard/Tenure";
const RoutesWithheader = () => {
  const pathName = window.location.href.substring(
    window.location.href.lastIndexOf("/") + 1
  );
  return (
    <>
      <Header
        title={
          pathName === "personalInfo" ? "Personal Details for KYC" :
            pathName === "manualKycLink" ? "get your live KYC done" :
              pathName === "connectBank" ? "add details to withdraw funds" :
                pathName === "personalInfoDetails" ? "Personal Details for KYC" :
                  pathName === "adharCardKyc" ? "get your live KYC done" :
                    pathName === "legalAuth" ? "legal authoritization" :
                      pathName === "lenderAgreement" ? "lender registration agreement" :
                      pathName === "faq" ? "help" :
                      pathName === "faqHelp" ? "help" :
                      pathName ===  "faqCongratulations" ? "help" :
                      pathName ===  "referEarn" ? "refer and earn" :
                        pathName === "investFund" ? "invest funds" : ""
        }
        showMenuDot
      />
      <Switch>
        <PrivateRoute exact path="/p2p/personalInfo" component={PersonalInfo} redirectTo="/"/>
        <Route exact path="/p2p/manualKycLink" component={ManualKycLink} />
        <Route exact path="/p2p/adharCardKyc" component={AdharCardKyc} />
        <PrivateRoute exact path="/p2p/connectBank" component={ConnectBank} redirectTo="/"/>
        <PrivateRoute exact path="/p2p/lenderAgreement" component={LenderAgreement} redirectTo="/"/>
        <PrivateRoute exact path="/p2p/payment-response" component={PaymentSuccess} redirectTo="/"/>
        <PrivateRoute exact path="/p2p/withdrawal" component={Withdrawal} redirectTo="/"/>
        <PrivateRoute exact path="/p2p/transactions" component={Transactions} redirectTo="/"/>
        <PrivateRoute exact path="/p2p/withdraw" component={WithdrawMoney} redirectTo="/"/>
        <Route exact path="/p2p/investmentSummary/:type" component={Investments} />
        <PrivateRoute exact path="/p2p/personalInfoSecond" component={PersonalInfoSecond} redirectTo="/"/>
        <PrivateRoute exact path="/p2p/borrowerInfo" component={BorrowerInfo} redirectTo="/"/>
        <PrivateRoute exact path="/p2p/investmentSummaryInfo" component={InvestmentSummaryInfo} redirectTo="/"/>
        <PrivateRoute exact path="/p2p/recentTransactions" component={RecentTransactions} redirectTo="/"/>
        <PrivateRoute exact path="/p2p/tenure" component={Tenure} redirectTo="/"/>
        <PrivateRoute
          exact
          path="/p2p/withdrawalSuccess"
          component={WithdrawalSuccess}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/dashboard"
          component={DashboardP2P}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/Addmoney"
          component={AddmoneyIndex}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/paymentMode"
          component={paymentMode}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/bank-detail"
          component={BankDetails}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/legalAuth"
          component={LegalAuth}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/investMore"
          component={InvestMore}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/tnc"
          component={LDCTerms}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/authorityLetter"
          component={AuthorityLetter}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/ldc-verify"
          component={LDCOTP}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/infop2p"
          component={InfoP2p}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/infoConfirmP2p"
          component={InfoConfirmP2p}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/referEarn"
          component={ReferEarn}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/kycExists"
          component={KycExists}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/personalInfoDetails"
          component={PersonalInfoDetails}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/investFund"
          component={InvestFund}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/ckycDetails"
          component={CkycDetails}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/faq"
          component={Faq}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/faqCongratulations"
          component={FaqCongratulations}
          redirectTo="/"
        />
        <PrivateRoute
          exact
          path="/p2p/faqHelp"
          component={FaqHelp}
          redirectTo="/"
        />
      </Switch>
    </>
  );
};

export default RoutesWithheader;